import { createMoney } from '../../../data/shared/money';
import moment from 'moment';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty'
import { getItemPrice } from '../../../data/booking/denormalizers/core';
import { CAR_TRANSPORT } from '../../../data/booking/constants/service_types';
import {OPEN} from "../../booking/constants/reservation_status";

const getDiscounts = (pricing) => {
    const { discounts } = pricing;

    if (null == discounts) {
        return [];
    }

    return discounts.map(function(discount) {
        return {
            label: discount.label,
            value: discount.value ? createMoney(discount.value) : null,
            type: discount.type,
            percentage: discount.percentage,
            serviceType: discount.serviceType,
            groupId:  discount.groupId
        }
    })

};

const getIncreases = (pricing) => {
    const { increases } = pricing;

    if (null == increases) {
        return [];
    }

    return increases.map(function(increase) {
        return {
            label: increase.label,
            value: increase.value ? createMoney(increase.value) : null,
            type: increase.type,
            percentage: increase.percentage,
            serviceType: increase.serviceType
        }
    })

};

const getIsFetching = state => state.followup.isFetching;

const formatPricing = (pricing) => {
    if(pricing) {
        return {
            ...pricing,
            subtotalWithoutTaxes: createMoney({
                amount: pricing.subtotalWithoutTaxes,
                currency: pricing.currency
            }),
            vats: pricing.vats.map(vat => ({
                ...vat,
                amount: createMoney({amount: vat.amount, currency: pricing.currency})
            })),
            subtotalWithTaxes: createMoney({
                amount: pricing.subtotalWithTaxes,
                currency: pricing.currency
            }),
            discounts: getDiscounts(pricing),
            increases: getIncreases(pricing),
            totalWithTaxes: createMoney({
                amount: pricing.totalWithTaxes,
                currency: pricing.currency
            }),
            discountsTotal: createMoney({
                amount: pricing.discountsTotal ? pricing.discountsTotal : 0,
                currency: pricing.currency
            }),
        };
    }
    return null;
};

const formatBalance = (pricing) => {
    if (!has(pricing, 'balance')) {
        return {
            totalPayments: null,
            totalRefunds: null,
            balance: null,
            transactions: null
        };
    }

    return {
        totalPayments: createMoney({
            amount: pricing.totalPayments,
            currency: pricing.currency
        }),
        totalRefunds: createMoney({
            amount: pricing.totalRefunds,
            currency: pricing.currency
        }),
        balance: createMoney({
            amount: pricing.balance,
            currency: pricing.currency
        }),
        transactions: pricing.transactions
    };
};

const formatData = (data, entities) => {
    const { services, pendingServices } = data;

    let mergedServices = services
    if(!isEmpty(pendingServices)) {
        pendingServices.forEach(service => {
            if (!mergedServices.includes(service)) {
                mergedServices.push(service)
            }
        })
    }

    return {
        ...data,
        startAt: moment(data.startAt),
        endAt: moment(data.endAt),
        createdAt: moment(data.createdAt),
        services: mergedServices.map(serviceId => {
            let service = null;
            let mergedItems = null
            if(isEmpty(entities.services[serviceId])){
                service = entities.pendingServices[serviceId]
                mergedItems = service.items
            } else {
                service = entities.services[serviceId];
                mergedItems = service.items
                if(entities.pendingServices && !isEmpty(entities.pendingServices[serviceId])){
                    entities.pendingServices[serviceId].items.forEach(itemId => {
                        if (!mergedItems.includes(itemId)) {
                            mergedItems.push(itemId)
                        }
                    })
                }
            }

            return {
                ...service,
                price: createMoney(service.price),
                isNew: isEmpty(entities.services[serviceId]),
                items: mergedItems.map(itemId => {
                    const pendingItem = !isEmpty(entities.pendingItems) ? entities.pendingItems[itemId] : null;
                    const item = !isEmpty(entities.items[itemId]) ? entities.items[itemId] : pendingItem;

                    return ({
                        ...item,
                        pendingItem: !isEmpty(pendingItem) && pendingItem.updateStatus == 'edited' ? pendingItem : null,
                        updateStatus: isEmpty(pendingItem) ? null : (pendingItem.updateStatus == 'edited' ? 'disabled' : pendingItem.updateStatus),
                        price: createMoney(item.price),
                        total: getItemPrice(service.type, item)
                    })
                })
            }
        }),
    }
};


const getData = (state) => {
    if (getIsFetching(state)) {
        return null;
    }

    const { result, entities } = state.followup;
    const data = entities.reservations[result];

    let formatedData = formatData(data, entities);
    let hasCarTransport = !isEmpty(formatedData.services.find(service => service.type == CAR_TRANSPORT))

    return {
        ...formatedData,
        pricing: {
            ...formatPricing(data.pricing),
            ...formatBalance(data.pricing)
        },
        hasCarTransport
    };
};

const getHistory = (state) => {
    if (getIsFetching(state)) {
        return null;
    }

    const { result, entities } = state.followup;
    const data = entities.reservations[result];

    return {
        unreadMessages: data.unreadMessages,
        entries: data.history.map(entry => ({
            ...entry,
            meta: {
                ...entry.meta,
                date: moment(entry.meta.date)
            }
        }))
    };
};

const isEditable = (data)=> {
    if('quotation' == data.type || ('reservation' == data.type && data.status == OPEN)){
        return true
    }
    return false;
}

const getShowAcceptQuotation = state => state.followup.acceptQuotation.showForm;
const getIsAcceptingQuotation = state => state.followup.acceptQuotation.isLoading;
const getShowAcceptingQuotationSuccess = state => state.followup.acceptQuotation.showSuccess;

const getShowPay = state => state.followup.pay.showForm;
const getPaymentMethod = state => state.followup.pay.method;
const getShowPaymentSuccess = state => state.followup.pay.showSuccess;
const getShowPaymentFailure = state => state.followup.pay.showError;
const getPayIsFetching = state => state.followup.pay.isFetching;
const getCreditCardFields = state => state.followup.pay.creditCardFields;


export {
    getIsFetching,
    getData,
    getHistory,
    getShowAcceptQuotation,
    getIsAcceptingQuotation,
    getShowAcceptingQuotationSuccess,
    getShowPay,
    getPaymentMethod,
    getShowPaymentSuccess,
    getShowPaymentFailure,
    getPayIsFetching,
    getCreditCardFields,
    isEditable
};

